import { isEmpty } from 'mc-ui-utils';
import { DEFAULT_INTERACTION_EXP_CONFIG } from '../constants/interaction';
export const getActiveInteractionVariant = (interactionExperiment) => {
    if (!isEmpty(interactionExperiment)) {
        return Object.keys(interactionExperiment).filter((key) => interactionExperiment[key])[0];
    }
};
export const getInteractionExperiment = (experiments) => {
    if (experiments.status === "resolved" /* RESOLVED */) {
        return experiments.data.glanceExperimentConfig.interactionExp;
    }
    if (experiments.status === "rejected" /* REJECTED */) {
        return DEFAULT_INTERACTION_EXP_CONFIG;
    }
    return null;
};
//# sourceMappingURL=interactionexputils.js.map